import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, FileText, CreditCard, Send } from 'lucide-react';
import { sendEmail } from '../services/emailService';

const AwardNomination = () => {
  const { categoryIds } = useParams();
  const [selectedCategories] = useState(categoryIds ? categoryIds.split(',').map(Number) : []);
  const [activeTab, setActiveTab] = useState('categories');

  const allCategories = [
    { id: 1, name: "Excellence in AI-Integrated Higher Education", price: 20000, category: "HIGHER EDUCATION CATEGORIES" }
  ];

  const getSelectedCategoryDetails = () => {
    return selectedCategories.map(id => allCategories.find(cat => cat.id === id)).filter(Boolean);
  };

  const renderCategoriesTab = () => (
    <div>
      <h2 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '30px' }}>
        Complete Your Award Nominations
      </h2>
      <p style={{ color: '#718096', fontSize: '1.1rem', marginBottom: '40px' }}>
        Choose your categories and proceed to payment to confirm your nomination. You can fill the nomination form before or after payment, and add more categories anytime.
      </p>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ color: '#2d3748', fontSize: '1.3rem', fontWeight: 600, marginBottom: '20px' }}>
          Pending Submission for:
        </h3>
        
        {getSelectedCategoryDetails().map((category) => (
          <div key={category.id} style={{
            backgroundColor: 'white',
            border: '2px solid #e2e8f0',
            borderRadius: '12px',
            padding: '25px',
            marginBottom: '20px'
          }}>
            <h4 style={{ color: '#2d3748', fontSize: '1.2rem', fontWeight: 700, marginBottom: '10px' }}>
              {category.name}
            </h4>
            <p style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 600, marginBottom: '15px' }}>
              {category.category}
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <span style={{ color: '#667eea', fontSize: '1.3rem', fontWeight: 700 }}>
                ₹ {category.price.toLocaleString()} +18% GST
              </span>
            </div>
            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
              <span style={{ color: '#e53e3e', fontSize: '0.9rem', fontWeight: 600 }}>Form filling yet to start</span>
              <span style={{ color: '#e53e3e', fontSize: '0.9rem', fontWeight: 600 }}>Payment Pending</span>
            </div>
            <div style={{ marginTop: '20px', display: 'flex', gap: '15px' }}>
              <Link 
                to={`/awards/form/${category.id}`}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#667eea',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: 600
                }}
              >
                Fill Form
              </Link>
              <button style={{
                padding: '10px 20px',
                backgroundColor: '#48bb78',
                color: 'white',
                border: 'none',
                borderRadius: '20px',
                fontSize: '0.9rem',
                fontWeight: 600,
                cursor: 'pointer'
              }}>
                Make Payment
              </button>
            </div>
          </div>
        ))}
      </div>

      <div style={{
        backgroundColor: '#f7fafc',
        padding: '25px',
        borderRadius: '12px',
        border: '2px solid #e2e8f0'
      }}>
        <p style={{ color: '#2d3748', fontSize: '1rem', marginBottom: '15px' }}>
          If you are facing any problem in filling nominations, You can contact us on:
        </p>
        <div>
          <p style={{ color: '#667eea', fontSize: '1rem', fontWeight: 600, marginBottom: '5px' }}>For Nominations</p>
          <p style={{ color: '#2d3748', fontSize: '0.9rem', marginBottom: '5px' }}>Akansha Gupta</p>
          <p style={{ color: '#2d3748', fontSize: '0.9rem', marginBottom: '5px' }}>akansha.gupta2@timesinternet.in</p>
          <p style={{ color: '#2d3748', fontSize: '0.9rem' }}>8447223200</p>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ padding: '40px 24px 0' }}>
        <div className="container-custom">
          <Link to="/awards/upcoming" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#667eea', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
            <ArrowLeft size={20} />
            <span>Back to Awards</span>
          </Link>
          
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h1 style={{ color: '#2d3748', fontSize: '2.5rem', fontWeight: 700, marginBottom: '10px' }}>TechEdu India Awards 2026</h1>
          </div>

          {/* Navigation Tabs */}
          <div style={{ display: 'flex', gap: '16px', marginBottom: '40px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[
              { key: 'categories', label: 'Categories', icon: '🏆' },
              { key: 'jury', label: 'Jury Members', icon: '👥' },
              { key: 'guidelines', label: 'Entry Guidelines', icon: '📋' },
              { key: 'criteria', label: 'Judging Criteria', icon: '⚖️' },
              { key: 'terms', label: 'T&C', icon: '📄' },
              { key: 'contact', label: 'Contact Us', icon: '📞' }
            ].map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                style={{
                  padding: '10px 20px',
                  borderRadius: '20px',
                  border: activeTab === tab.key ? 'none' : '2px solid #667eea',
                  backgroundColor: activeTab === tab.key ? '#667eea' : 'transparent',
                  color: activeTab === tab.key ? 'white' : '#667eea',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}
              >
                <span>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="container-custom" style={{ padding: '0 24px 80px' }}>
        {activeTab === 'categories' && renderCategoriesTab()}
        {activeTab === 'jury' && (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>Jury Members</h2>
            <p style={{ color: '#718096', fontSize: '1.1rem' }}>Information about our esteemed jury members will be available soon.</p>
          </div>
        )}
        {activeTab === 'guidelines' && (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>Entry Guidelines</h2>
            <p style={{ color: '#718096', fontSize: '1.1rem' }}>Detailed entry guidelines and submission requirements will be provided here.</p>
          </div>
        )}
        {activeTab === 'criteria' && (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>Judging Criteria</h2>
            <p style={{ color: '#718096', fontSize: '1.1rem' }}>Information about our judging criteria and evaluation process.</p>
          </div>
        )}
        {activeTab === 'terms' && (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>Terms & Conditions</h2>
            <p style={{ color: '#718096', fontSize: '1.1rem' }}>Terms and conditions for award nominations and participation.</p>
          </div>
        )}
        {activeTab === 'contact' && (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>Contact Us</h2>
            <p style={{ color: '#718096', fontSize: '1.1rem' }}>Get in touch with our team for any queries or support.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AwardNomination;